import React from 'react';

const ChristmasBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      {/* Sky Aura */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.16) 0%, rgba(239, 68, 68, 0.12) 35%, transparent 65%), radial-gradient(circle at 20% 80%, rgba(251, 191, 36, 0.10) 0%, transparent 60%)'
        }}
      />

      <svg
        viewBox="0 0 1600 1000"
        className="w-full h-full object-cover"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="auroraGrad" x1="0%" y1="0%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="#10B981" stopOpacity="0.35" />
            <stop offset="45%" stopColor="#06B6D4" stopOpacity="0.4" />
            <stop offset="85%" stopColor="#8B5CF6" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#EF4444" stopOpacity="0.15" />
          </linearGradient>
          <linearGradient id="chaletGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#2A1B14" />
            <stop offset="100%" stopColor="#120B07" />
          </linearGradient>
          <radialGradient id="windowGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FEF08A" />
            <stop offset="60%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#B45309" />
          </radialGradient>
          <filter id="starGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" />
          </filter>
        </defs>

        {/* Aurora Borealis Ribbon */}
        <path d="M0 120 Q400 40 800 140 T1600 100 L1600 0 L0 0 Z" fill="url(#auroraGrad)" />
        <path d="M0 180 Q500 100 1000 200 T1600 160 L1600 0 L0 0 Z" fill="url(#auroraGrad)" opacity="0.6" />

        {/* Distant Alpine Peaks */}
        <polygon points="120,480 320,240 520,480" fill="#0D1930" />
        <polygon points="320,240 280,310 320,330 350,300" fill="#E2E8F0" opacity="0.85" />

        <polygon points="450,520 700,200 950,520" fill="#0A1426" />
        <polygon points="700,200 650,280 700,310 740,270" fill="#F8FAFC" opacity="0.9" />

        <polygon points="850,500 1100,260 1350,500" fill="#0D1930" />
        <polygon points="1100,260 1060,330 1100,350 1130,320" fill="#E2E8F0" opacity="0.85" />

        <polygon points="1250,540 1450,320 1650,540" fill="#0A1426" />
        <polygon points="1450,320 1420,380 1450,400 1480,370" fill="#F8FAFC" opacity="0.9" />

        {/* Dense Winter Pine Forest Layer */}
        <g fill="#071322">
          <polygon points="60,650 90,540 120,650" />
          <polygon points="100,660 140,510 180,660" />
          <polygon points="160,650 200,530 240,650" />
          <polygon points="230,670 270,500 310,670" />
          <polygon points="350,680 400,490 450,680" />
          <polygon points="1150,660 1200,480 1250,660" />
          <polygon points="1220,670 1270,510 1320,670" />
          <polygon points="1300,680 1350,490 1400,680" />
          <polygon points="1420,670 1470,520 1520,670" />
          <polygon points="1480,680 1530,500 1580,680" />
        </g>

        {/* Snow Draped Hills */}
        <path d="M-50 780 Q400 660 900 760 T1650 740 L1650 1000 L-50 1000 Z" fill="#0E2138" />
        <path d="M-50 850 Q500 750 1100 860 T1650 820 L1650 1000 L-50 1000 Z" fill="#091626" />

        {/* Cozy Alpine Chalet (Left Midground) */}
        <g transform="translate(180, 680)">
          {/* Chalet Wall */}
          <rect x="0" y="40" width="110" height="70" fill="url(#chaletGrad)" rx="3" />
          {/* Steep Snowy Roof */}
          <polygon points="55,0 -15,45 125,45" fill="#F8FAFC" stroke="#E2E8F0" strokeWidth="2" />
          {/* Smoking Stone Chimney */}
          <rect x="80" y="5" width="16" height="35" fill="#475569" />
          {/* Glowing Windows with warm candlelight */}
          <rect x="15" y="55" width="28" height="28" fill="url(#windowGlow)" rx="4" />
          <line x1="29" y1="55" x2="29" y2="83" stroke="#2A1B14" strokeWidth="2" />
          <line x1="15" y1="69" x2="43" y2="69" stroke="#2A1B14" strokeWidth="2" />

          <rect x="65" y="55" width="28" height="28" fill="url(#windowGlow)" rx="4" />
          <line x1="79" y1="55" x2="79" y2="83" stroke="#2A1B14" strokeWidth="2" />
          <line x1="65" y1="69" x2="93" y2="69" stroke="#2A1B14" strokeWidth="2" />
        </g>

        {/* Cozy Alpine Chalet (Right Midground) */}
        <g transform="translate(1320, 690)">
          <rect x="0" y="35" width="100" height="65" fill="url(#chaletGrad)" rx="3" />
          <polygon points="50,0 -12,40 112,40" fill="#F8FAFC" stroke="#E2E8F0" strokeWidth="2" />
          <rect x="72" y="8" width="14" height="30" fill="#475569" />
          <rect x="18" y="50" width="26" height="26" fill="url(#windowGlow)" rx="4" />
          <rect x="58" y="50" width="26" height="26" fill="url(#windowGlow)" rx="4" />
        </g>

        {/* Victorian Street Lamps with Amber Glow Pools */}
        <g transform="translate(340, 720)">
          <circle cx="6" cy="6" r="28" fill="#F59E0B" fillOpacity="0.25" filter="url(#starGlow)" />
          <rect x="4" y="10" width="4" height="70" fill="#1E293B" />
          <polygon points="0,10 12,10 9,0 3,0" fill="#FBBF24" />
          <polygon points="-2,0 14,0 6,-8" fill="#0F172A" />
        </g>

        <g transform="translate(1260, 730)">
          <circle cx="6" cy="6" r="28" fill="#F59E0B" fillOpacity="0.25" filter="url(#starGlow)" />
          <rect x="4" y="10" width="4" height="70" fill="#1E293B" />
          <polygon points="0,10 12,10 9,0 3,0" fill="#FBBF24" />
          <polygon points="-2,0 14,0 6,-8" fill="#0F172A" />
        </g>
      </svg>
    </div>
  );
};

export default ChristmasBackgroundGraphics;
